"use client";

import { Suspense } from "react";
import Link from "next/link";

export default function NotFound() {
  return (
    <Suspense>
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full text-center px-6">
          <div className="mb-8">
            <h1 className="text-9xl font-bold text-gray-200">404</h1>
          </div>
          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-2">
              Page not found
            </h2>
            <p className="text-gray-600">
              Sorry, we couldn&apos;t find the page you&apos;re looking for.
            </p>
          </div>
          <div className="space-y-4">
            <Link
              href="/"
              className="inline-block px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
            >
              Go back home
            </Link>
            <div>
              <button
                onClick={() => window.history.back()}
                className="text-blue-600 hover:text-blue-700 font-medium"
              >
                Go back to previous page
              </button>
            </div>
          </div>
        </div>
      </div>
    </Suspense>
  );
}
